import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';

import { Home, Product, Cart, Login, Register, Checkout, ProductsByCategory, PageNotFound, Summary } from './pages';
import { Chatbot } from './components';

const locales = ['us-en', 'us-es', 'us-zh'];

const renderSharedRoutes = () => (
  <>
    <Route index element={<Home />} />
    <Route path='category/:category' element={<ProductsByCategory />} />
    <Route path='product/:id' element={<Product />} />
    <Route path='cart' element={<Cart />} />
    <Route path='login' element={<Login />} />
    <Route path='register' element={<Register />} />
    <Route path='checkout' element={<Checkout />} />
    <Route path='summary' element={<Summary />} />
    <Route path='product/*' element={<PageNotFound />} />
    <Route path='*' element={<PageNotFound />} />
  </>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <div className='modal fade' id='exampleModal' tabIndex='-1' aria-labelledby='exampleModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='exampleModalLabel'>
              Modal title
            </h5>
            <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>Test for action button url</div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-secondary' data-bs-dismiss='modal'>
              Close
            </button>
            <button type='button' className='btn btn-primary' data-bs-dismiss='modal'>
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <Provider store={store}>
      <Routes>
        <Route path='/' element={<Outlet />}>
          {renderSharedRoutes()}
        </Route>
        {locales.map((locale) => (
          <Route key={locale} path={`/${locale}`} element={<Outlet />}>
            {renderSharedRoutes()}
          </Route>
        ))}
      </Routes>
      <Chatbot />
    </Provider>
  </BrowserRouter>,
);
